import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userPaymentValidation, userCreditValidation } from './validation'
import dayjs from 'dayjs'

export const useUserPaymentForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userPaymentValidation()),
    initialValues: {
      payment_id: '',
      remarks: '',
      value: '',
    },
    transformValues: (values) => {
      return {
        payment_id: Number(values.payment_id),
        remarks: values.remarks,
        value: values.value,
      }
    }
  })
}

export const useUserCreditForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userCreditValidation()),
    initialValues: {
      created_at: new Date(),
      method: 'increase',
      label: 'Bonus',
      amount: 0,
      order_id: null,
      supplier_id: null
    },

    transformValues: (values) => {
      const payload = {
        created_at: dayjs(values.created_at).format('YYYY-MM-DD HH:mm:ss'),
        amount: Number(values.amount),
        commission_type: values.method === 'increase' ? 1 : 2,
        label: values.label
      }
      if (values.order_id) {
        payload.order_id = values.label === 'Order Commision' || values.label === 'Sales' ? Number(values.order_id) : null
      }
      if (values.supplier_id) {
        payload.supplier_id = values.label === 'Sales' ? Number(values.supplier_id) : null
      }
      return payload
    }
  })
}